import {Action} from '../../common/types/common';

export const GET_UTM_URL_ACTION: Action = {
    name: 'GET_UTM_URL_ACTION',
    action: (url: string) => ({
        url,
        type: GET_UTM_URL_ACTION.name
    })
};

export const GET_PARAMS_URL_ACTION: Action = {
    name: 'GET_PARAMS_URL_ACTION',
    action: (url: string) => ({
        url,
        type: GET_PARAMS_URL_ACTION.name
    })
};

export const SET_UTM_VALUES_ACTION: Action = {
    name: 'SET_UTM_VALUES_ACTION',
    action: (aHttpRefer: string, userAgent: string, typeDevice: string,
             operatingSystem: string, resolutionWidth: number, resolutionHeight: number) => ({
                 aHttpRefer, userAgent, typeDevice, operatingSystem, resolutionWidth, resolutionHeight,
                 type: SET_UTM_VALUES_ACTION.name
             })
};

export const SET_VEHICLE_UTM_VALUES_ON_SIMULATOR: Action = {
    name: 'SET_VEHICLE_UTM_VALUES_ON_SIMULATOR',
    action: (price: string, downPayment: string, year: string,
             brand: string, model: string, version: string, province: string, hasInsurance: boolean, idVehicle: string,
             groupName: string, groupId: string, groupLocation: string, isUrlFromPI: boolean, originalPhoto: string,
             thumbnailPhoto: string, vpiQS: string
    ) => ({
        price, downPayment, year, brand, model, version, province, hasInsurance, idVehicle, groupName, groupId,
        groupLocation, isUrlFromPI, originalPhoto, thumbnailPhoto, vpiQS,
        type: SET_VEHICLE_UTM_VALUES_ON_SIMULATOR.name
    })
};